import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { ModuleMenu, INSTRUCTION } from '../../../models/common';
import { HeadService } from '../../../services/common/headservice';
import { CommonService } from '../../../services/common.service';
import { GrantsSummaryService } from '../../../services/grants/grants-summary.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eap-user-instructions-modal',
  templateUrl: './eap-user-instructions-modal.component.html',
  styleUrls: ['./eap-user-instructions-modal.component.scss']
})
export class EapUserInstructionsModalComponent implements OnInit {
  id: number;
  isAck = false;
  menudata: ModuleMenu;
  instruction: INSTRUCTION;
  title: string = "";
  description: string = "";
  constructor(
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private router: Router,
    private dataShare: IstDataShareService,
    private header: HeadService,
    private commonService: CommonService,
    private summaryService: GrantsSummaryService,
  ) { }

  ngOnInit() {
    this.getGrantsInstructions();
  }

  add() {
    this.modalRef.dismiss();
    this.dataShare.setApplicationID("");
    this.commonService.setEAPApp(null);
    this.commonService.appId = "";

    this.menudata = new ModuleMenu();
    this.menudata.module = "EAP";
    this.menudata.operation = "New";
    this.menudata.appId = "";
    this.menudata.formstate = "Draft";

    this.header.setHeader(this.menudata);
    this.dataShare.setApplicationID("");
    this.router.navigate(['/home/eap/my-applications/application-ext/:0/program_info'], { skipLocationChange: true, queryParams: { module: "eap", id: 0, app_ext: true, screen_type: "my-applications" } })
  }
  getGrantsInstructions() {
    let instructionid = "4"
    this.summaryService.getInstruction(instructionid).subscribe(summary => {
      this.instruction = summary;
      if (this.instruction != null) {
        this.title = this.instruction.NAME;
        this.description = this.instruction.DESCRIPTION;
      }

    });
  }
}
